import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized, msg } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { spinnerStyles } from './spinner.styles.js';
let HlxSpinner = class HlxSpinner extends HelixElement {
    render() {
        return html `
            <svg part="base" class="hlx-spinner" role="progressbar" aria-label="${msg('Loading')}">
                <circle class="hlx-spinner-track"></circle>
                <circle class="hlx-spinner-indicator"></circle>
            </svg>
        `;
    }
};
HlxSpinner.styles = [componentStyles, spinnerStyles];
__decorate([
    query('[part~="base"]')
], HlxSpinner.prototype, "base", void 0);
HlxSpinner = __decorate([
    customElement('hlx-spinner'),
    localized()
], HlxSpinner);
export { HlxSpinner };
//# sourceMappingURL=spinner.js.map